import React, { useEffect, useState } from "react";
import styles from "../CommonStyles/commonformstyles.module.scss";
import "./profiledetails.scss";
import userImg from "../../../../assets/images/editforms/user.png";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "../../../../components/Button/Button";
import Cookie from "js-cookie";
import useMultipleFileUploadAws from "../../../../hooks/AWSFileUpload/useMultipleFileUploadAws";
import LinearProgressBar from "../../../../components/ProgressBar/LinearProgressBar";
import { useUpdatePartnerDetails } from "../../../../hooks/partnerHook/usePartner";
import { useSelector } from "react-redux";
import { randomDescriptions } from "./description";
import { RiAiGenerate } from "react-icons/ri";

function ProfileDetailsForm() {
  const {
    uploadErrors,
    uploadFileToS3,
    cancelUpload,
    resetFileUploadState,
    mediaUrls,
    uploadProgresses,
    estimatedTimes,
  } = useMultipleFileUploadAws();

  const navigate = useNavigate();
  const location=useLocation();
  const userData = useSelector((state) => state.partner.user);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    displayName: "",
    phoneNumber: "",
    profilePicture: null,
    profilePictureUrl: null,
    description: "",
    languages: [],
  });

  useEffect(() => {
    if (userData) {
      setFormData((prevData) => ({
        ...prevData,
        firstName: userData.partner.first_name,
        lastName: userData.partner.last_name,
        displayName: userData.partner.display_name,
        phoneNumber: userData.partner.contact_number,
        profilePictureUrl: userData.profile_img,
        description: userData.partner.description || "",
      }));
    }
  }, [userData]);

  const [profilePicturePreview, setProfilePicturePreview] = useState("");
  const [errors, setErrors] = useState({});
  const [languageInput, setLanguageInput] = useState("");
  const [suggestedLanguages, setSuggestedLanguages] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [allLanguages, setAllLanguages] = useState([]);

  const languages = useSelector((state) => state.siteData.userLanguages);

  useEffect(() => {
    if (languages && languages.length > 0) {
      setAllLanguages([...languages]);
    }
  }, [languages]);

  useEffect(() => {
    if (selectedFile && mediaUrls[selectedFile.name]) {
      setFormData((prevData) => ({
        ...prevData,
        profilePictureUrl: mediaUrls[selectedFile.name],
      }));
    }
  }, [mediaUrls, selectedFile]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];

    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert("File must be less than 5MB in size!");
        return;
      }

      setSelectedFile(file);
      setFormData({ ...formData, profilePicture: file });
      setErrors({ ...errors, profilePicture: "" });

      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePicturePreview(reader.result);
      };
      reader.readAsDataURL(file);

      // Upload to S3
      uploadFileToS3(file);
    }
  };

  const handleLanguageInputChange = (e) => {
    const value = e.target.value;
    setLanguageInput(value);

    if (value) {
      const suggestions = allLanguages.filter((lang) =>
        lang.name.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestedLanguages(suggestions);
    } else {
      setSuggestedLanguages([]);
    }
  };

  const handleSelectLanguage = (language) => {
    console.log("Language:", language);
    if (!formData.languages.some((lang) => lang.id === language.id)) {
      setFormData({
        ...formData,
        languages: [
          ...formData.languages,
          { id: language.id, name: language.name },
        ],
      });
      setErrors({ ...errors, languages: "" });
    }
    setLanguageInput("");
    setSuggestedLanguages([]);
  };

  const handleRemoveLanguage = (language) => {
    setFormData({
      ...formData,
      languages: formData.languages.filter((lang) => lang !== language),
    });
  };

  const validateForm = () => {
    const newErrors = {};
  
    if (!formData.firstName?.trim())
      newErrors.firstName = "Please enter the first name";
  
    if (!formData.lastName?.trim())
      newErrors.lastName = "Please enter the last name";
  
    if (!formData.displayName?.trim())
      newErrors.displayName = "Please enter your display name";
  
    if (!formData.phoneNumber?.trim()) {
      newErrors.phoneNumber = "Please enter a valid phone number";
    } else if (formData.phoneNumber.trim().length !== 10) {
      newErrors.phoneNumber = "Phone number must be 10 digits";
    }
  
    if (!formData.description?.trim())
      newErrors.description = "Please add some description";
  
    if (formData.languages?.length === 0)
      newErrors.languages = "Please add at least one language";
  
    return newErrors;
  };
  const {
    mutate: profileUpdate,
    isPending,
    isError,
    isSuccess,
  } = useUpdatePartnerDetails();

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      console.log("Form Data:", formData);
      const { profilePicture, ...filteredData } = formData;
      profileUpdate(filteredData);
    (!location.pathname.includes("edit-profile")  &&
      navigate('/welcome/professional-details'));
    }
  };

  useEffect(() => {
    if (isSuccess) {
      const isNewUser = Cookie.get("newUser");
      if (isNewUser) {
        navigate("/dashboard");
      } else {
        navigate(-1, { replace: true });
      }
    }
  }, [isSuccess]);

  const triggerFileInput = () => {
    document.getElementById("profilePictureInput").click();
  };

  const generateDescription = () => {
    const randomIndex = Math.floor(Math.random() * randomDescriptions.length);
    setFormData((prevData) => ({
      ...prevData,
      description: randomDescriptions[randomIndex],
    }));
  };

  return (
    <div>
    <div className="progress">
    <span>Step 1 of 3</span>
    <span className="info">*Mandatory field</span>
     </div>


    <div className={`profile-form ${styles.formContainer}`}>
      
      
      <h1 className={styles.formPageHeading}>Personal Info</h1>
      {/* <p className={styles.formpageSubHeading}>
        Tell us a bit about yourself. This information will appear on your
        public profile, so that potential buyers can get to know you better.
      </p> */}
      <form className="personal-details-form" onSubmit={handleSubmit}>
        <div className="input-field-cont">
          <label className={styles.inputLabel} htmlFor="firstName">
           Full Name*
          </label>
          <div className="multiple-input-field">
            <div className="input-field">
              <input
                type="text"
                name="firstName"
                placeholder="Enter First Name"
                value={formData.firstName}
                onChange={handleInputChange}
                className={`${errors.firstName ? "highlight-input-field" : ""}`}
              />
              {errors.firstName && (
                <p className="input-error">{errors.firstName}</p>
              )}
            </div>

            <div className="input-field">
              <input
                type="text"
                name="lastName"
                placeholder="Enter Last Name"
                value={formData.lastName}
                onChange={handleInputChange}
                className={`${errors.lastName ? "highlight-input-field" : ""}`}
              />
              {errors.lastName && (
                <p className="input-error">{errors.lastName}</p>
              )}
            </div>
          </div>
        </div>

        <div className="input-field-cont">
          <label htmlFor="displayName" className={styles.inputLabel}>
            Display Name
          </label>
          <p className="label-detail">
          We're making it easier for customers to know who they're working with by introducing display names. We recommend using your first name and the initial of your last name for a more authentic connection.
          </p>

          <div className="input-field">
            <input
              type="text"
              name="displayName"
              value={formData.displayName}
              placeholder="Enter Display Name"
              onChange={handleInputChange}
              className={`${errors.displayName ? "highlight-input-field" : ""}`}
            />
            {errors.displayName && (
              <p className="input-error">{errors.displayName}</p>
            )}
          </div>
        </div>

        <div className="input-field-cont">
          <label htmlFor="phoneNumber" className={styles.inputLabel}>
           Phone Number
          </label>
          <div className="input-field">
            <div className="phone-num-cont">
              <span className="phone-number-initial">+91</span>
              <input
                type="tel"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                maxLength={10}
                minLength={10}
                className={`${
                  errors.phoneNumber ? "highlight-input-field" : ""
                }`}
                placeholder="Enter Phone Number"
              />
            </div>
            {errors.phoneNumber && (
              <p className="input-error">{errors.phoneNumber}</p>
            )}
          </div>
        </div>

        <div className="input-field-cont">
          <label htmlFor="profilePicture" className={styles.inputLabel}>
             Profile Picture
          </label>
          <p className="label-detail">
          A profile picture helps build trust and allows customers to see who they're hiring. Please add one to your profile.
          </p>
          <div className="image-preview" onClick={triggerFileInput}>
            {formData.profilePictureUrl ? (
              <img src={formData.profilePictureUrl} alt="Profile Preview" />
            ) : profilePicturePreview ? (
              <img src={profilePicturePreview} alt="Profile Preview" />
            ) : (
              <img src={userImg} alt="" />
            )}
          </div>
          <input
            type="file"
            id="profilePictureInput"
            name="profilePicture"
            accept="image/*"
            onChange={handleFileUpload}
            style={{ display: "none" }}
          />
          {formData.profilePicture && (
            <div className="showProgress">
              <LinearProgressBar
                height="0.5rem"
                bgColor="linear-gradient(to right, #DCE35B,#45B649)"
                progress={uploadProgresses[selectedFile.name]}
              />
            </div>
          )}
          <Button
            label={"Change Image"}
            handleClick={triggerFileInput}
            customStyle={{
              padding: "0.5rem",
              fontSize: "0.9rem",
              fontWeight: "500",
              border: "1px solid grey",
            }}
          />
          {errors.profilePicture && (
            <p className="input-error">{errors.profilePicture}</p>
          )}
        </div>

        <div className="input-field-cont">
          <label htmlFor="description" className={styles.inputLabel}>
            Description
          </label>
          <p className="label-detail">
            Clearly outlines what you provide, helping customers understand your
            value proposition.
          </p>

          <div className="input-field">
            <textarea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              className={`${errors.description ? "highlight-input-field" : ""}`}
            />
            {errors.description && (
              <p className="input-error">{errors.description}</p>
            )}
          </div>
          <button
            className="generate-desc"
            onClick={generateDescription}
            type={"button"}
          >
            {" "}
            <RiAiGenerate /> Generate Description
          </button>
        </div>

        <div className="input-field-cont">
          <label htmlFor="languages" className={styles.inputLabel}>
            Languages
          </label>
          <p className="label-detail">
            Select which languages you can communicate in and your proficiency
            level.
          </p>

          <div className="input-field">
            <input
              type="search"
              value={languageInput}
              onChange={handleLanguageInputChange}
              placeholder="Enter a language"
              className={`${errors.languages ? "highlight-input-field" : ""}`}
            />
            {suggestedLanguages.length > 0 && (
              <ul className="suggestions-list">
                {suggestedLanguages.map((language, index) => (
                  <li
                    key={index}
                    onClick={() => handleSelectLanguage(language)}
                  >
                    {language.name}
                  </li>
                ))}
              </ul>
            )}
            {errors.languages && (
              <p className="input-error">{errors.languages}</p>
            )}
          </div>
          <div className="selected-languages-cont">
            {formData.languages.length > 0 && <h4>Selected Languages</h4>}
            <div className="selected-languages">
              {formData.languages.map((language, index) => (
                <div key={index} className="language-card">
                  <span>{language.name}</span>
                  <span
                    className="remove-icon"
                    onClick={() => handleRemoveLanguage(language)}
                  >
                    &#x2715;
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="save-btn">
          <Button
            label={isPending ? "Updating..." : "Save Details"}
            type="submit"
            // disabled={isPending}
            customStyle={{
              backgroundColor: "green",
              color: "white",
              border: "none",
              padding:"10px 60px"
            }}
          />
        </div>
      </form>
    </div>
    </div>
  );
}

export default ProfileDetailsForm;
